import React from 'react';

const PermissionCheckboxList = ({ 
  permissions, 
  userPermissions, 
  onChange, 
  disabled = false,
  showDescriptions = true 
}) => {
  const handlePermissionChange = (permissionName, checked) => {
    onChange({
      ...userPermissions,
      [permissionName]: checked
    });
  };

  const formatPermissionName = (name) => {
    return name
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-gray-900">Permissions</h4>
      <div className="space-y-3">
        {permissions.map((permission) => (
          <div key={permission.id} className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id={`permission-${permission.id}`}
                name={`permission-${permission.name}`}
                type="checkbox"
                checked={userPermissions[permission.name] || false}
                onChange={(e) => handlePermissionChange(permission.name, e.target.checked)}
                disabled={disabled}
                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded disabled:opacity-50"
              />
            </div>
            <div className="ml-3 text-sm">
              <label 
                htmlFor={`permission-${permission.id}`} 
                className="font-medium text-gray-700 cursor-pointer"
              >
                {formatPermissionName(permission.name)}
              </label>
              {showDescriptions && permission.description && (
                <p className="text-gray-500 text-xs mt-1">
                  {permission.description}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PermissionCheckboxList; 